export const PRICE_TO_PAY_PREFIX = `Pay`
export const PRICE_TO_PAY_SUFFIX = `Deposit`
export const DEPOSIT_PAYMENT_OPTION = 'deposit'
export const FULL_PAYMENT_OPTION = 'full'
export const GET_QUANTITY_FROM_ORDERITEM = 'orderItem';
export const GET_QUANTITY_FROM_NUM_PEOPLE = 'num_people';